<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { LinkButton } from '$global/components/LinkButton';

	let { slug, dataCy, fullWidth = false, ...rest }: Props = $props();

	interface Props {
		slug: string;
		dataCy: string;
		fullWidth?: boolean | undefined;
		class?: string;
	}
</script>

<LinkButton
	size="md"
	dataCy={`${dataCy}-drop-info`}
	variant="secondary"
	href={`${GlobalRoutes.EditionsHome}/${slug}`}
	class={rest.class}
	{fullWidth}
>
	Drop info
</LinkButton>
